import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import "./CtaBanner.css";

const PHONE = "03338820922";
const PHONE_DISPLAY = "0333 8820922";

const CtaBanner = () => {
  return (
    <section className="cta-banner">
      <div className="cta-banner-bg" aria-hidden="true" />

      <div className="cta-banner-inner">
        <div className="cta-banner-copy">
          <p className="cta-banner-eyebrow">Need something custom?</p>
          <h2 className="cta-banner-title">
            Can't find what
            <br />
            you're looking for?
          </h2>
          <p className="cta-banner-text">
            Our expert travel agents are ready to build the perfect trip for you. Get in touch and we'll handle everything.
          </p>
        </div>

        <div className="cta-banner-actions">
          <Link to="/contact" className="cta-banner-btn cta-banner-btn-primary">
            <MessageCircle />
            Get a Free Quote
            <ArrowRight className="cta-banner-arrow" />
          </Link>
          <a href={`tel:${PHONE}`} className="cta-banner-btn cta-banner-btn-secondary">
            <Phone />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
